import classNames from 'classnames';
import React, {useState} from 'react';

import {useI18n} from '@udemy/i18n';
import {AdvertisingBanner} from '@udemy/react-messaging-components';

import styles from './personal-plan-banner.module.less';
import {ValuePlanBannerModal} from './value-plan-banner-modal.react-component';

interface ValuePlanBannerProps {
    className?: string;
}

export const ValuePlanBanner: React.FC<ValuePlanBannerProps> = ({className}) => {
    const {gettext} = useI18n();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleLearnMoreClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={className} data-testid="value-plan-banner">
            <AdvertisingBanner
                className={classNames(styles.banner)}
                background="light"
                title={gettext('Udemy Value Plan')}
                titleClassName="ud-heading-lg"
                subtitle={gettext(
                    'Your curated plan of quality courses selected to help you build skills that matter, at great value.',
                )}
                subtitleClassName={classNames(styles.subtitle, 'ud-text-sm')}
                submitButtonText={gettext('Learn more')}
                submitButtonProps={{
                    udStyle: 'ghost',
                    typography: 'ud-text-sm',
                    className: 'ud-link-underline',
                    componentClass: 'a',
                    onClick: handleLearnMoreClick,
                    size: 'small',
                }}
            />
            <ValuePlanBannerModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>
    );
};
